import React from 'react';
import { Link } from 'react-router-dom';
import BrandMark from './BrandMark';

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <BrandMark className="site-footer__brand-mark" />
          <p>Life Journal — quiet clarity for the hours that matter.</p>
        </div>
        <nav className="site-footer__links" aria-label="Footer">
          <Link to="/product#journey">How it works</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/about">About</Link>
          <Link to="/login">Log in</Link>
          <Link to="/signup">Sign up</Link>
          <Link to="/terms">Terms</Link>
        </nav>
        <p className="site-footer__copy">© {new Date().getFullYear()} 3AM AI</p>
      </div>
    </footer>
  );
}
